import createVueComponent from '../createVueComponent';

const AlarmClock = createVueComponent('AlarmClockIcon', [
  ['circle', { cx: '12', cy: '13', r: '8' }],
  ['path', { d: 'M12 9v4l2 2' }],
  ['path', { d: 'M5 3L2 6' }],
  ['path', { d: 'M22 6l-3-3' }],
  ['path', { d: 'M6 19l-2 2' }],
  ['path', { d: 'M18 19l2 2' }],
]);

export default AlarmClock;
